import React from 'react';
import { Button, type ButtonProps } from '@mui/material';
import styled from '@emotion/styled';

const StyledTableButton = styled(Button)`
  && {
    justify-content: flex-start;
    text-align: left;
    width: 100%;
    padding: 0;
    min-width: unset;
    margin: 0;
    color: inherit;
    & .MuiSvgIcon-root {
      color: inherit;
    }
    &:focus-visible {
      outline: 2px solid var(--color-white);
      outline-offset: 2px;
    }
    &:hover {
      background-color: transparent;
      color: inherit;
    }
  }
`;

export const arrowStylingDefault = {
  transition: 'transform 150ms ease',
};

export const arrowStyling = {
  transform: 'rotate(-180deg)',
  transition: 'transform 150ms ease',
};

interface SortableHeaderButtonProps extends ButtonProps {
  isSorted: boolean;
  sortDirection?: 'asc' | 'desc';
}

export const SortableHeaderButton = ({
  isSorted,
  sortDirection,
  children,
  ...buttonProps
}: SortableHeaderButtonProps) => (
  <StyledTableButton {...buttonProps}>
    {children}
    <span className="sr-only">
      {!isSorted
        ? 'not sorted'
        : sortDirection === 'asc'
          ? 'sorted ascending'
          : 'sorted descending'}
    </span>
  </StyledTableButton>
);
